import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { isWithinInterval, parseISO } from 'date-fns'
import { endOf, endOfToday, FMT, klass, newDate, PumpkinTimer, startOf, useScheduledRefresh } from 'utils'
import { FooterMsg, FooterState } from 'components/FooterMsg'
import Btn from 'components/buttons/Btn'
import { getDates, getUpdatedAt, updateDates } from 'state/Orders'
import { useActiveRestaurant } from 'state/Restaurants'

export default function Footer({ isFuture }) {
	const { t }      = useTranslation()
	const dispatch   = useDispatch()
	const dates      = useSelector(getDates)
	const pumpkinSet = PumpkinTimer.isset()
	const activeTz   = useActiveRestaurant()?.timezone_id

	const isoDates = {
		start: startOf(parseISO(dates.start)),
		end  : endOf(parseISO(dates.end)),
	}
	const hasToday = isWithinInterval(newDate(null), isoDates)

	function goToToday() {
		const today = FMT.dateISO(newDate(null))
		dispatch(updateDates(today, today))
	}

	//forces the footer to refresh (since its visuals are date-dependent) once midnight strikes, if the Pumpkin timer is
	// off (its changes would already cause a rerender because of the actual date in the state changes)
	const whenMidnightStrikes = (endOfToday().getTime() + 1000) - newDate(null).getTime()
	useScheduledRefresh(whenMidnightStrikes, !pumpkinSet, true, [activeTz])

	return <footer>
		<FooterMsg {...klass({ screaming: !hasToday })}>
			{!isFuture && <Trans>
				Viewing{' '}
				<strong {...klass({ textBoldReset: hasToday })}>
					{{ datesPeriod: FMT.period(isoDates.start, isoDates.end, true) }}
				</strong>
			</Trans>}
			{!hasToday && !isFuture &&
				<><br/><Btn variant="success" size="sm" onClick={goToToday} className="mt-2 mb-1">{t('Go to today\'s orders')}</Btn></>}
		</FooterMsg>
		<FooterState selector={getUpdatedAt} formatter={d => d? FMT.date(d, { forceTZ: true }) : 'unknown'} prefix={t("Last updated at")}/>
	</footer>
}

Footer.propTypes = {
	isFuture: PropTypes.bool.isRequired
}
